


// MachineBarChart.jsx
import React from "react";
import { Box, Card, CardContent, Typography, GlobalStyles } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../theme/theme";

export default function ProdMachineBarchart({ data }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const nivoTheme = {
        axis: {
            domain: { line: { stroke: colors.grey[400] } },
            ticks: { line: { stroke: colors.grey[500] }, text: { fill: colors.grey[100] } },
            legend: { text: { fill: colors.grey[100] } },
        },
        grid: { line: { stroke: theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[200] } },
        legends: { text: { fill: colors.grey[100] } },
        tooltip: { container: { background: colors.primary[400], color: colors.grey[100] } },
    };

    const barData = data.map((d) => ({ machine: d.machine, qty: d.qty }));

    return (
        <div style={{
            "--nivo-tooltip-bg": colors.primary[400],
            "--nivo-tooltip-color": colors.grey[100],
        }}>
            {/* FIX: Override faulty Nivo tooltip */}
            <GlobalStyles
                styles={{
                    ".chart-tooltip__colored-square": {
                        display: "none !important",
                    },
                }}
            />


            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                <CardContent>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
                        Machine Wise Production (Today)
                    </Typography>

                    <Box sx={{ height: 360 }}>
                        <ResponsiveBar
                            data={barData}
                            keys={["qty"]}
                            indexBy="machine"
                            margin={{ top: 30, right: 30, bottom: 80, left: 80 }}
                            padding={0.35}
                            theme={nivoTheme}
                            colors={{ scheme: theme.palette.mode === "dark" ? "dark2" : "set2" }}
                            borderRadius={6}
                            axisBottom={{
                                tickSize: 5,
                                tickPadding: 8,
                                tickRotation: -35,
                            }}
                            axisLeft={{
                                tickSize: 5,
                                tickPadding: 8,
                                legend: "Quantity",
                                legendPosition: "middle",
                                legendOffset: -60,
                            }}
                            tooltip={({ id, value, indexValue, color }) => (
                                <div
                                    style={{
                                        padding: 8,
                                        background: colors.primary[400],
                                        color: colors.grey[100],
                                        borderRadius: 6,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                    }}
                                >
                                    {/* FIX: Replace default white square with your own themed square */}
                                    <div
                                        style={{
                                            width: 12,
                                            height: 12,
                                            background: color,       // ← use bar color
                                            borderRadius: 3,
                                        }}
                                    />

                                    <div>
                                        <strong>{indexValue}</strong>
                                        <div>{id}: {value}</div>
                                    </div>
                                </div>
                            )}

                        />
                    </Box>
                </CardContent>
            </Card>
        </div>
    );
}

